
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 21h6","stroke":"#140047","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.269 9.75A6.74 6.74 0 0112.051 3c3.712.028 6.68 3.113 6.68 6.835v.665c0 3.358.703 5.306 1.322 6.371A.75.75 0 0119.408 18H4.592a.749.749 0 01-.645-1.13c.62-1.064 1.322-3.013 1.322-6.37v-.75z","stroke":"#004ADB","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    